import React from "react";
import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Stack,
  InputLabel,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import "../../setorku/_setorku.scss";
import DataTable from "presentation/components/DataTable";
import LayoutComponent from "presentation/layout/Layout";
import usePPOBPartnerViewModel from "./PPOBPartnerViewModel";
import ModalContainer from "presentation/components/ModalContainer";
import { Controller } from "react-hook-form";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  bgcolor: "white",
  borderRadius: "20px",
  p: 4,
};

const PPOBPartnerComponent = () => {
  const {
    data,
    modal,
    closeModal,
    page,
    setPage,
    pageSize,
    setPageSize,
    columns,
    t,
    handleSubmit,
    control,
    submitFilter,
    submitAdd,
    submitEdit,
  } = usePPOBPartnerViewModel();

  return (
    <LayoutComponent>
      <Container
        maxWidth={false}
        sx={{ height: "100vh", backgroundColor: { xs: "#fff", md: "#f4f4f4" } }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            paddingTop: "2rem",
          }}
        >
          <Box
            sx={{
              width: "100%",
              backgroundColor: "white",
              boxShadow: "0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
              borderRadius: "8px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "rgba(34, 136, 102, 0.12)",
              },
            }}
          >
            <Grid
              container
              sx={{
                boxShadow: { sm: "0 0 5px #ddd" },
                padding: "1rem",
              }}
            >
              <Stack
                direction="row"
                className="headerSetorku"
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  "@media (max-width: 600px)": {
                    flexDirection: "column",
                  },
                }}
              >
                <Typography
                  className="headerName"
                  variant="h6"
                  component="h1"
                  sx={{
                    mb: "1.5rem",
                    fontWeight: 600,
                  }}
                >
                  {t("ppob.partner.partner_header")}
                </Typography>

                <Stack spacing={1} direction="row" className="headerButton" sx={{
                  "@media (max-width: 600px)": {
                    width: "100%",
                    pb: "1rem",
                  },
                }}>
                    <Button
                      variant="outlined"
                      sx={{
                        height: "42px",
                        color: "rgba(34, 136, 102, 0.5)",
                        borderColor: "rgba(34, 136, 102, 0.5) !important",
                        "@media (max-width: 600px)": {
                          width: "100%",
                        },
                      }}
                      onClick={() => closeModal('filter')}
                    >
                      {t("ppob.partner.filter_button")}
                    </Button>
                  <Button
                    onClick={() => closeModal('add')}
                    variant="contained"
                    sx={{
                      height: "42px",
                      borderColor: "rgba(34, 136, 102, 0.5)",
                      color: "#FFFFFF",
                      backgroundColor: "rgba(40, 99, 83, 1) !important",
                      shadows: "rgba(0, 0, 0, 0.12)",
                      "@media (max-width: 600px)": {
                        width: "100%",
                      },
                    }}
                  >
                    {t("ppob.partner.add_button")}
                  </Button>
                </Stack>
              </Stack>

                    {data.partnerList.loading ? (
                      <h1>Loading...</h1>
                    ) : (
                <DataTable
                  {...{
                    data: data.partnerList.data.list ,
                    totalRows: data.partnerList.data.total,
                    columns,
                    setPage,
                    setPageSize,
                    page,
                    pageSize,
                  }}
                />
                    )}
            </Grid>
          </Box>
        </div>

        <ModalContainer open={modal.edit} onClose={() => closeModal('edit')} applyButton={handleSubmit(submitEdit)}>
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <Controller
              name="edit.partnerId"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  disabled
                  variant="outlined"
                  label={t("ppob.partner.id_partner")}
                  {...field}
                />
              )}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <Controller
              name="edit.partnerName"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  variant="outlined"
                  label={t("ppob.partner.partner_name")}
                  {...field}
                />
              )}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <Controller
              name="edit.response"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Select
                  variant="outlined"
                  label={t("ppob.partner.response")}
                  {...field}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <Controller
              name="edit.access"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Select
                  variant="outlined"
                  label={t("ppob.partner.access")}
                  {...field}
                >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          </ModalContainer>

        <ModalContainer open={modal.add} onClose={() => closeModal('add')} applyButton={handleSubmit(submitAdd)} >
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <Controller
              name="add.partnerId"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  variant="outlined"
                  label={t("ppob.partner.id_partner")}
                  {...field}
                />
              )}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <Controller
              name="add.partnerName"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  variant="outlined"
                  label={t("ppob.partner.partner_name")}
                  {...field}
                />
              )}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <InputLabel id="demo-simple-select-label">
              {t("ppob.partner.response")}
            </InputLabel>
            <Controller
              name="add.response"
              control={control}
              render={({ field }) => (
                <Select
                  labelId="demo-simple-select-label"
                  variant="outlined"
                  label={t("ppob.partner.response")}
                  {...field}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: "1rem" }}>
            <InputLabel id="demo-simple-select-label">
              {t("ppob.partner.access")}
            </InputLabel>
            <Controller
              name="add.access"
              control={control}
              render={({ field }) => (
                <Select
                  labelId="demo-simple-select-label"
                  variant="outlined"
                  label={t("ppob.partner.access")}
                  {...field}
                >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                </Select>
              )}
            />
          </FormControl>
        </ModalContainer>

        <ModalContainer open={modal.filter} onClose={() => closeModal('filter')} applyButton={handleSubmit(submitFilter)} >
          <Typography variant="h6" sx={{ mb: "1rem" }}>
            WAITING DESIGN
          </Typography>
        </ModalContainer>

      </Container>
    </LayoutComponent>
  );
};

export default PPOBPartnerComponent;